/**
DT custom: this script runs on every page and is ment to perform basic optimizations and minor tweaks.
*/

// Page has loaded and theme assets are ready, see theme.js
(function () {
  "use strict";

  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    // replace Vimeo links imported from magento with iframe embed
    const videos = document.querySelectorAll("a.VideoLink");
    videos.forEach((video) => {
      const img = video.querySelector("img");
      if (img) {
        video.removeChild(img);
      }
      const el = document.createElement("div");
      el.setAttribute("class", "embed-container");
      let videoLink = video.getAttribute("href") || "";
      if (videoLink.startsWith("//")) {
        videoLink = "https:" + videoLink;
      }
      el.innerHTML = `<div class="video-wrapper"><iframe src="${videoLink}" title="${video.innerText.trim()}"></iframe></div>`;
      video.parentElement.appendChild(el);
    });
  });
})();
